"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactQuickFacts = require("@nerdwallet/react-quick-facts");
var _default = function _default(_ref) {
  var marketplaceEntity = _ref.marketplaceEntity;
  return {
    drivers: [_reactQuickFacts.mappings.investing.getQuickFactFees(marketplaceEntity), _reactQuickFacts.mappings.investing.getQuickFactAccountMinimum(marketplaceEntity), _reactQuickFacts.mappings.investing.getQuickFactPromotion(marketplaceEntity)]
  };
};
exports.default = _default;